export default __webpack_public_path__ + "static/media/skunk.884f56c0.png";